import { useEffect, useState } from 'react';
import type { WidgetProps } from '@frontend/widgets/types';
import { fetchWidgetData } from '../api';

interface Commit {
	sha: string;
	message: string;
	author: string;
	date: string | null;
	htmlUrl: string | null;
	repo: string;
}

export default function GiteaRecentCommitsWidget({ contextType, contextId, ecosystemId }: WidgetProps) {
	const [commits, setCommits] = useState<Commit[]>([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState('');

	useEffect(() => {
		setLoading(true);
		setError('');
		const params: Record<string, string> = { ecosystemId, contextType, contextId };

		fetchWidgetData<{ commits: Commit[] }>('gitea-recent-commits', params)
			.then((d) => setCommits(d.commits || []))
			.catch((err: Error) => setError(err.message))
			.finally(() => setLoading(false));
	}, [contextType, contextId, ecosystemId]);

	if (loading) return <div className="widget-inner-loading">Loading commits…</div>;
	if (error) return <div className="widget-inner-error">{error}</div>;
	if (!commits.length) return <div className="widget-inner-empty">No recent commits found.</div>;

	return (
		<ul className="widget-list">
			{commits.map((c, i) => (
				<li key={i} className="widget-list-item">
					<div className="widget-list-primary">
						{c.htmlUrl
							? <a href={c.htmlUrl} target="_blank" rel="noopener noreferrer">{c.message.split('\n')[0]}</a>
							: <span>{c.message.split('\n')[0]}</span>
						}
					</div>
					<div className="widget-list-meta">
						{c.repo && <span>{c.repo.split('/').pop()}</span>}
						<span>{c.author}</span>
						{c.date && <span>{new Date(c.date).toLocaleDateString()}</span>}
					</div>
				</li>
			))}
		</ul>
	);
}
